import React from 'react';
import { BottomNav } from './BottomNav';

// Standard in-app page shell: centered mobile column + bottom nav spacing.
export const AppShell = ({ children, nav = true, className = '' }) => (
  <div className="min-h-screen" style={{ background: 'var(--background)' }}>
    <div className={`mx-auto max-w-md px-4 ${nav ? 'pb-28' : 'pb-6'} pt-4 ss-fade-in ${className}`}>
      {children}
    </div>
    {nav && <BottomNav />}
  </div>
);

export const PageHeader = ({ title, subtitle, right }) => (
  <div className="flex items-start justify-between mb-4">
    <div>
      <h1 className="text-2xl font-extrabold tracking-tight" style={{ color: 'var(--text)' }}>{title}</h1>
      {subtitle && <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>}
    </div>
    {right}
  </div>
);
